import Vue from 'vue';
import userDetails from '@/components/pages/AdminHomePage/users/userDetails/userDetails.vue'

Vue.component('userdetails', userDetails);
